import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../../components/header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FooterComponent } from '../../../components/footer/footer.component';
import { AuthService } from '../../../services/auth.service';
import { AccountInfo } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
  ],
  template: `
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <!-- Logged-in: let the router handle what to show (HomeComponent redirects based on role) -->
    <ng-container *ngIf="user; else notLoggedIn">
      <router-outlet></router-outlet>
    </ng-container>

    <!-- Not logged in: show welcome/login screen -->
    <ng-template #notLoggedIn>
      <div class="flex items-center justify-center min-h-[calc(100vh-200px)] bg-gradient-to-br from-green-50 to-blue-50">
        <div class="text-center px-6 py-12 max-w-2xl">
          <div class="mb-8">
            <i class="fas fa-shield-alt text-6xl text-green-600 mb-4"></i>
          </div>
          <h1 class="text-4xl font-bold text-gray-900 mb-4">
            Welcome to ClearScrap Control Center
          </h1>
          <p class="text-lg text-gray-600 mb-8">
            This is an admin portal for managing appointments, customers, agents, and more.
            Please login to access the control center.
          </p>
          <button
            (click)="login()"
            class="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-lg hover:from-green-700 hover:to-green-600 transition-all duration-200 shadow-lg hover:shadow-xl font-semibold text-lg">
            <i class="fas fa-sign-in-alt mr-3"></i>
            Login to Continue
          </button>
        </div>
      </div>
    </ng-template>

    <app-footer></app-footer>
  `,
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  user: AccountInfo | null = null;
  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.user$
      .pipe(
        filter(user => !!user),
        takeUntil(this.destroy$)
      )
      .subscribe(user => {
        this.user = user;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login() {
    this.authService.loginRedirect();
  }
}